import React from 'react';
import { useStyles } from './Storage.styles';
import largeImage from '../../../assets/images/sizes/large.png';
import mediumImage from '../../../assets/images/sizes/medium.png';
import smallImage from '../../../assets/images/sizes/small.png';
import { isMedium, isLarge } from '../../../assets/containerSizes/containerSizes';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
const getImage = (volume) => {
    if (isLarge(volume)) {
        return largeImage;
    }
    if (isMedium(volume)) {
        return mediumImage;
    }
    else {
        return smallImage;
    }
};
export const Storage = (props) => {
    const classes = useStyles();
    const image = getImage(props.volume);
    return (React.createElement(Box, { component: "div", sx: classes.root },
        React.createElement(Box, { component: "div", sx: classes.img },
            React.createElement("img", { alt: "storage", src: image })),
        React.createElement(Box, { component: "div", sx: classes.textContent },
            React.createElement(Typography, { variant: "h4", sx: classes.title }, props.containerCode),
            React.createElement(Typography, { variant: "h5", sx: classes.title },
                "D\u00F6rr ",
                props.storageCode,
                " - ",
                props.facilityLevel),
            props.facilityName && React.createElement(Typography, null, props.facilityName),
            props.rentedBy && (React.createElement(Typography, { variant: "h6", sx: classes.paragraph },
                "Hyrestagare: ",
                React.createElement("br", null),
                props.rentedBy)),
            props.startDate && (React.createElement(Typography, { variant: "h6", sx: classes.paragraph },
                "\u00C5tkomst tidigast: ",
                React.createElement("br", null),
                format(new Date(props.startDate), 'PPpp', { locale: sv }))))));
};
export default Storage;
